"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableOptionRowGroup = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var selectable_option_row_1 = require("../selectable-option-row");
var stack_1 = require("../stack");
function SelectableOptionRowGroup(_a) {
    var options = _a.options, _b = _a.active, active = _b === void 0 ? undefined : _b, onChange = _a.onChange, _c = _a.boldLabels, boldLabels = _c === void 0 ? false : _c;
    var handleChange = function (val) {
        if (onChange && val !== active)
            onChange(val);
    };
    return (react_1.default.createElement(stack_1.Stack, { direction: "vertical", gap: 8 }, options.map(function (option) {
        var id = Math.random().toString();
        return (react_1.default.createElement(selectable_option_row_1.SelectableOptionRow, { boldLabels: boldLabels, badgeText: option.badgeText, badgeType: option.badgeType, hint: option.hint, isActive: active === option.value, key: id, label: option.label, onChange: handleChange, subtitle: option.subtitle, value: option.value }));
    })));
}
exports.SelectableOptionRowGroup = SelectableOptionRowGroup;
//# sourceMappingURL=index.js.map